import script from "./UiOnClickOutside.vue?vue&type=script&lang=js"
export * from "./UiOnClickOutside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__